import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {catchError, throwError} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { MyOrdersComponent } from '../../order-manager/my-orders/my-orders.component';
import {CustomerModel} from "../../../models-otc/customer-model";
import {CustomerService} from "../../../services-otc/customer.service";
import {OrderManagerService} from "../../../services-otc/order-manager.service";
import {OrderStatusModel} from "../../../models-otc/order-status-model";
import dayjs from "dayjs";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Role } from 'src/app/models/role';
import { PlantsModel } from 'src/app/order-to-cash/models-otc/plants-model';
import { MaterialModel } from 'src/app/order-to-cash/models-otc/material-model';
import { OrdinaryMaterialModel } from 'src/app/order-to-cash/models-otc/ordinary-material-model';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD.MM.YYYY"
    },
    display: {
      dateInput: "DD.MM.YYYY",
      monthYearLabel: "DD.MM.YYYY",
      dateA11yLabel: "DD.MM.YYYY",
      monthYearA11yLabel: "DD.MM.YYYY"
    }
  };

@Component({
    selector: 'app-filter-my-orders',
    templateUrl: './filter-my-orders.component.html',
    styleUrls: ['./filter-my-orders.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FilterMyOrdersComponent implements  OnInit{
    selectedStatusIds = [];
    selectedClientIds = [];
    selectedPlantIds: number[] = [];
    selectedMaterialIds: number[] = [];
    userRoles: Role[] = JSON.parse(sessionStorage.getItem('roles'));
    plantList: PlantsModel[] = [];
    filterPlantList: PlantsModel[] = [];
    materialList: OrdinaryMaterialModel[] = [];
    filterMaterialList: OrdinaryMaterialModel[] = [];
    materialFilterCtrl: FormControl = new FormControl();
    plantFilterCtrl: FormControl = new FormControl();
    clientFilterCtrl: FormControl = new FormControl();
    statusFilterCtrl: FormControl = new FormControl();

    statusList: OrderStatusModel [];
    filterStatusList: OrderStatusModel[] = [];
    customers: CustomerModel[];
    filterCustomerList: CustomerModel[] = [];

    startDate: string;
    endDate: string;


    constructor( @Inject(MAT_DIALOG_DATA) public data: any,
                 public dialogRef: MatDialogRef<MyOrdersComponent>,
                 private customerService: CustomerService,
                 private fb: FormBuilder,
                 private  orderManagerService: OrderManagerService,
    ) { }
    ngOnInit(): void {
        this.materialFilterCtrl.valueChanges.subscribe({
            next: res => {
            this.filterMaterialList = [...this.materialList.filter(c => c?.description?.toLowerCase().includes(res.toLowerCase()))];
            }
        });

        this.plantFilterCtrl.valueChanges.subscribe({
            next: res => {
            this.filterPlantList = [...this.plantList.filter(c => c?.name?.toLowerCase().includes(res.toLowerCase()) || c?.plantCode?.toLowerCase().includes(res.toLowerCase()))];
            }
        });

        this.clientFilterCtrl.valueChanges.subscribe({
            next: res => {
            this.filterCustomerList = [...this.customers.filter(c => c?.name?.toLowerCase().includes(res.toLowerCase()))];
            }
        });

        this.statusFilterCtrl.valueChanges.subscribe({
            next: res => {
            this.filterStatusList = [...this.statusList.filter(c => c?.description?.toLowerCase().includes(res.toLowerCase()))];
            }
        });

        this.selectedClientIds = this.data?.filterResult?.clientIds;
        this.selectedStatusIds = this.data?.filterResult?.statusIds;
        this.startDate = this.data?.filterResult?.startDate;
        this.endDate = this.data?.filterResult?.endDate;

        if(this.data?.materialList) {
            this.materialList = this.data?.materialList;
            this.filterMaterialList = [...this.materialList];
            this.plantList = this.data.plantList;
            this.filterPlantList = [...this.plantList];
            this.selectedPlantIds = this.data?.filterResult?.plantIds;
            this.selectedMaterialIds = this.data?.filterResult?.materialIds;
        }
        this.populateCustomerDetails();
        this.populateOrderStatusList();
    }


    populateCustomerDetails() {
        this.customerService.getCustomerDetails()
            .pipe(
                catchError((error) => {
                    console.error(error);
                    return throwError(() => error);
                })
            )
            .subscribe((response) => {
                this.customers = response;
                this.filterCustomerList = [...this.customers];
            });
    }

    populateOrderStatusList() {
        this.orderManagerService.getOrderStatusList()
            .pipe(
                catchError((error) => {
                    console.error(error);
                    return throwError(() => error);
                })
            ).subscribe((response) => {
            this.statusList = response;

            if(this.statusList?.length > 0 && this.userRoles?.length > 0) {
                if(this.data?.filterResult?.forApprovals) {
                    let roleIndex = this.userRoles?.findIndex(r => r.name?.toLowerCase().includes('approvingmanager') && r.name?.toLowerCase().includes('otc'));
                    if(roleIndex !== -1) {
                        let isOverallApprover = this.userRoles[roleIndex].name.includes('OTCOverallApprovingManager');
                        this.statusList = this.statusList.filter(s => s.description.toLowerCase().includes(isOverallApprover ? "pending" : "pending manager approval"));
                    }
                } else if(this.data?.filterResult?.forApproved) {
                    this.statusList = this.statusList.filter(s => !s.description.toLowerCase().includes("draft"));
                }
            }

            this.filterStatusList = [...this.statusList];

            
        });
    }

    cancelFileringMyOrders(){
        this.dialogRef.close();
    }

    setFilterStartDate(event: MatDatepickerInputEvent<Date>): void {
        this.startDate = event.target?.value ? dayjs(event.target?.value).format('YYYY-MM-DD') : '';
    }

    setFilterEndDate(event: MatDatepickerInputEvent<Date>): void {
        this.endDate = event.target?.value ? dayjs(event.target?.value).format('YYYY-MM-DD') : '';
    }

    // setFilterDates(){
    //     if(this.filterStartDate && this.filterEndDate){
    //         this.filterForm = this.fb.group({
    //             filterStartDate: this.filterStartDate,
    //             filterEndDate: this.filterEndDate,
    //         });
    //     }
    // }
    applyFileringMyOrders() {
        const filterValues = {
            statusIds: this.selectedStatusIds,
            clientIds: this.selectedClientIds,
            startDate: this.startDate,
            endDate:  this.endDate,
            plantIds: this.selectedPlantIds,
            materialIds: this.selectedMaterialIds
        }
        this.dialogRef.close(filterValues);
    }
}
